"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _networkUtils = require("../networkUtils");
var _config = _interopRequireDefault(require("../config.js"));
var _utils = require("./utils.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Analytics Manager class for handling multiple analytics platforms
 * Supports GA4, Mixpanel, and Sentry with filtering and configuration options
 */
var AnalyticsManager = /*#__PURE__*/function () {
  function AnalyticsManager() {
    (0, _classCallCheck2["default"])(this, AnalyticsManager);
    this.adapters = {};
    this.analyticsInitialisationConfig = {};
    this.apiErrorWhitelist = [];
    this.initialized = false;
    this.SKIP_ANALYTICS = false;
    this.__UNIQUE_ID__ = Math.random();
    this.trackingOptions = {};
  }

  /**
   * Extracts URL context information including organization name, module name, and query parameters
   * @returns {Object} URL context with org_name, module_name, full_path, and query_params
   */
  return (0, _createClass2["default"])(AnalyticsManager, [{
    key: "getUrlContext",
    value: function getUrlContext() {
      try {
        var pathSegments = window.location.pathname.split('/').filter(Boolean);
        var urlContext = {};
        // add path segment so that we can filter on survey_id or review_id
        pathSegments.forEach(function (segment, index) {
          urlContext["path_segment_".concat(index + 1)] = segment;
        });
        return _objectSpread({
          org_name: pathSegments[0] || null,
          module_name: pathSegments[1] || null,
          full_path: window.location.pathname,
          module_version: process.env.REACT_APP_VERSION,
          query_params: Object.fromEntries(new URLSearchParams(window.location.search))
        }, urlContext);
      } catch (error) {
        console.error('[AnalyticsManager] getUrlContext error:', error);
        return {};
      }
    }

    /**
     * Automatically registers analytics adapters for GA4, Mixpanel, and Sentry
     * Loads adapters dynamically and handles loading errors gracefully
     */
  }, {
    key: "autoRegisterAdapters",
    value: function autoRegisterAdapters() {
      var _this = this;
      var platforms = ['ga4', 'mixpanel', 'sentry'];
      platforms.forEach(function (name) {
        try {
          _this.adapters[name] = require("./adapters/".concat(name))["default"];
        } catch (e) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn("[AnalyticsManager] Adapter '".concat(name, "' failed to load:"), e.message);
          }
        }
      });
    }

    /**
     * Updates tracking options for analytics platforms
     * @param {Object} options - Configuration options for tracking
     */
  }, {
    key: "updateTrackingOptions",
    value: function updateTrackingOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.trackingOptions = options;
    }

    /**
     * Loads and initializes analytics configuration for all platforms
     * Sets up adapters, configuration, and initializes each enabled platform
     * @param {Object} options - Configuration options including apiErrorWhitelist and useSecureCookie
     */
  }, {
    key: "loadConfig",
    value: function loadConfig() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      try {
        if (this.SKIP_ANALYTICS) return;
        this.analyticsInitialisationConfig = {
          ga4: {
            googleAnalytics: _config["default"].googleAnalytics,
            enable: true
          },
          mixpanel: {
            mixpanelToken: _config["default"].mixpanelToken,
            enable: true
          },
          sentry: {
            sentryDsn: _config["default"].sentryDns,
            enable: true
          }
        };
        this.trackingOptions = options;
        this.apiErrorWhitelist = options.apiErrorWhitelist || [];
        this.autoRegisterAdapters();
        this.initialized = true;

        // Init each adapter with its own config and options
        for (var _i = 0, _Object$entries = Object.entries(this.adapters); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
            platform = _Object$entries$_i[0],
            adapter = _Object$entries$_i[1];
          var platformConfig = _objectSpread(_objectSpread(_objectSpread({}, this.analyticsInitialisationConfig[platform]), this.trackingOptions[platform]), {}, {
            // this is required for ga4 as of now
            useSecureCookie: options.useSecureCookie
          });
          if (platformConfig !== null && platformConfig !== void 0 && platformConfig.enable && typeof adapter.init === 'function') {
            try {
              adapter.init(platformConfig);
            } catch (e) {
              console.error("[AnalyticsManager] ".concat(platform, " init error:"), e);
            }
          }
        }
      } catch (error) {
        console.error('[AnalyticsManager] loadConfig error:', error);
      }
    }

    /**
     * Normalizes filter arrays to ensure consistent structure
     * @param {Array} filters - Array of filter objects
     * @returns {Array} Normalized filter array with constant_value and regex_value properties
     */
  }, {
    key: "normalizeFilters",
    value: function normalizeFilters() {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return filters.map(function (filter) {
        var type = filter.type,
          value = filter.value,
          constant_value = filter.constant_value,
          regex_value = filter.regex_value;
        return {
          type: type,
          constant_value: constant_value || (Array.isArray(value) ? value : []),
          regex_value: regex_value || []
        };
      });
    }

    /**
     * Checks if properties match any of the provided filters
     * @param {Array} filters - Array of filter objects
     * @param {Object} properties - Properties to check against filters
     * @returns {boolean} True if properties match any filter
     */
  }, {
    key: "matchFilters",
    value: function matchFilters(filters, properties) {
      try {
        return filters.some(function (filter) {
          var input = properties[filter.type];
          if (!input) return false;
          return (filter.constant_value || []).includes(input) || (filter.regex_value || []).some(function (r) {
            return new RegExp(r).test(input);
          });
        });
      } catch (error) {
        console.error('[AnalyticsManager] matchFilters error:', error);
        return false;
      }
    }

    /**
     * Determines if an event should be tracked for a specific platform based on filters
     * @param {string} platform - Analytics platform name
     * @param {Object} properties - Event properties to check
     * @returns {boolean} True if event should be tracked
     */
  }, {
    key: "shouldTrack",
    value: function shouldTrack(platform, properties) {
      try {
        var platformConfig = _objectSpread(_objectSpread({}, this.analyticsInitialisationConfig[platform]), this.trackingOptions[platform]);
        if (!(platformConfig !== null && platformConfig !== void 0 && platformConfig.enable)) return false;
        var whitelist = this.normalizeFilters(platformConfig.whitelist || []);
        var blacklist = this.normalizeFilters(platformConfig.blacklist || []);
        if (whitelist.length && !this.matchFilters(whitelist, properties)) return false;
        if (blacklist.length && this.matchFilters(blacklist, properties)) return false;
        return true;
      } catch (error) {
        console.error('[AnalyticsManager] shouldTrack error:', error);
        return false;
      }
    }

    /**
     * Tracks an analytics event across all enabled platforms
     * Sanitizes email addresses and adds URL context to event properties
     * @param {string} category - Event category
     * @param {string} action - Event action
     * @param {string} label - Event label (optional)
     * @param {*} value - Event value (optional)
     * @param {Object} otherProperties - Additional event properties
     */
  }, {
    key: "trackEvent",
    value: function trackEvent(category, action, label, value) {
      var otherProperties = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      try {
        if (this.SKIP_ANALYTICS || !(0, _networkUtils.isNetworkActive)()) return;
        var route = window.location.pathname;
        var finalLabel = label || "".concat(route, "?").concat(window.location.search).toLowerCase();
        category = (0, _utils.replaceEmailsInString)(category.toLowerCase(), 'given_email');
        action = (0, _utils.replaceEmailsInString)(action.toLowerCase(), 'given_email');
        finalLabel = (0, _utils.replaceEmailsInString)(finalLabel.toLowerCase(), 'given_email');
        var enhancedProperties = _objectSpread(_objectSpread({}, otherProperties), this.getUrlContext());
        for (var _i2 = 0, _Object$entries2 = Object.entries(this.adapters); _i2 < _Object$entries2.length; _i2++) {
          var _Object$entries2$_i = (0, _slicedToArray2["default"])(_Object$entries2[_i2], 2),
            platform = _Object$entries2$_i[0],
            adapter = _Object$entries2$_i[1];
          if (!this.shouldTrack(platform, _objectSpread({
            category: category,
            action: action,
            label: label,
            value: value,
            route: route
          }, enhancedProperties))) continue;
          try {
            var _adapter$trackEvent;
            (_adapter$trackEvent = adapter.trackEvent) === null || _adapter$trackEvent === void 0 || _adapter$trackEvent.call(adapter, category, action, finalLabel, value, enhancedProperties);
          } catch (e) {
            console.warn("[AnalyticsManager] ".concat(platform, " trackEvent error:"), e);
          }
        }
      } catch (error) {
        console.error('[AnalyticsManager] trackEvent error:', error);
      }
    }

    /**
     * Tracks errors across analytics platforms with special handling for Sentry
     * Extracts error details and creates Sentry alerts for non-whitelisted errors
     * @param {string} errorType - Type of error
     * @param {Error} error - Error object (optional)
     * @param {boolean} fatal - Whether the error is fatal
     * @param {boolean} createSentryAlert - Whether to create Sentry alert
     * @param {Object} otherProperties - Additional error properties
     */
  }, {
    key: "trackError",
    value: function trackError(errorType) {
      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var fatal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var createSentryAlert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var otherProperties = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      try {
        if (this.SKIP_ANALYTICS || !(0, _networkUtils.isNetworkActive)()) return;
        try {
          var description = errorType != null ? errorType.toString().toLowerCase() : '';
          var error_string = errorType;
          if (error != null) {
            var _error$config, _error$response;
            if (error.name) otherProperties.errorName = error.name;
            if (error.message) otherProperties.errorMessage = error.message;
            if (error.code) otherProperties.errorCode = error.code;
            if ((_error$config = error.config) !== null && _error$config !== void 0 && _error$config.url) otherProperties.endpoint = error.config.url;
            if ((_error$response = error.response) !== null && _error$response !== void 0 && _error$response.data) otherProperties.response = error.response.data;

            // Handle Sentry error tracking
            if (createSentryAlert && this.adapters.sentry) {
              var isWhitelisted = this.apiErrorWhitelist.includes(description) || (error === null || error === void 0 ? void 0 : error.message) && this.apiErrorWhitelist.includes(error.message);
              if (!this.shouldTrack('sentry', _objectSpread({
                errorType: description,
                error: error,
                fatal: fatal,
                createSentryAlert: createSentryAlert
              }, otherProperties))) return;
              if (!isWhitelisted) {
                this.adapters.sentry.trackError(description, error, fatal, createSentryAlert, otherProperties);
              }
            }
          }
          error_string = (0, _utils.replaceEmailsInString)(error_string, 'given_email');

          // Track as a regular event for all platforms
          this.trackEvent('error', description, "fatal:".concat(fatal), error_string, otherProperties);
        } catch (e) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn('[AnalyticsManager] trackError error:', e);
          }
        }
      } catch (error) {
        console.error('[AnalyticsManager] trackError error:', error);
      }
    }

    /**
     * Sets user ID across all analytics platforms
     * @param {string|number} userId - User identifier
     */
  }, {
    key: "setUserId",
    value: function setUserId(userId) {
      if (this.SKIP_ANALYTICS) return;
      var id = (userId || '').toString().toLowerCase();
      for (var _i3 = 0, _Object$values = Object.values(this.adapters); _i3 < _Object$values.length; _i3++) {
        var adapter = _Object$values[_i3];
        try {
          var _adapter$setUserId;
          (_adapter$setUserId = adapter.setUserId) === null || _adapter$setUserId === void 0 || _adapter$setUserId.call(adapter, id);
        } catch (e) {
          console.warn('[AnalyticsManager] setUserId error:', e);
        }
      }
    }

    /**
     * Sets custom dimension across all analytics platforms
     * @param {string} dimension - Dimension name
     * @param {*} value - Dimension value
     */
  }, {
    key: "setCustomDimension",
    value: function setCustomDimension(dimension, value) {
      if (this.SKIP_ANALYTICS) return;
      for (var _i4 = 0, _Object$values2 = Object.values(this.adapters); _i4 < _Object$values2.length; _i4++) {
        var adapter = _Object$values2[_i4];
        try {
          var _adapter$setCustomDim;
          (_adapter$setCustomDim = adapter.setCustomDimension) === null || _adapter$setCustomDim === void 0 || _adapter$setCustomDim.call(adapter, dimension, value);
        } catch (e) {
          console.warn('[AnalyticsManager] setCustomDimension error:', e);
        }
      }
    }

    /**
     * Placeholder for timing tracking functionality
     * Currently not implemented
     * @param {string} category - Timing category
     * @param {string} variable - Timing variable
     * @param {number} value - Timing value
     * @param {string} label - Timing label
     */
  }, {
    key: "trackTiming",
    value: function trackTiming(category, variable, value) {
      var label = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      // Placeholder for future Analytics timing support
      console.log('[AnalyticsManager] trackTiming is not implemented yet');
    }

    /**
     * Tracks page views across all analytics platforms
     * @param {string} path - Page path (defaults to current location)
     */
  }, {
    key: "trackPageView",
    value: function trackPageView() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.pathname;
      if (this.SKIP_ANALYTICS || !(0, _networkUtils.isNetworkActive)()) return;
      for (var _i5 = 0, _Object$entries3 = Object.entries(this.adapters); _i5 < _Object$entries3.length; _i5++) {
        var _Object$entries3$_i = (0, _slicedToArray2["default"])(_Object$entries3[_i5], 2),
          platform = _Object$entries3$_i[0],
          adapter = _Object$entries3$_i[1];
        try {
          var _adapter$trackPageVie;
          (_adapter$trackPageVie = adapter.trackPageView) === null || _adapter$trackPageVie === void 0 || _adapter$trackPageVie.call(adapter, path);
        } catch (e) {
          console.warn("[AnalyticsManager] ".concat(platform, " trackPageView error:"), e);
        }
      }
    }
  }]);
}();
var _default = exports["default"] = new AnalyticsManager();